import { __awaiter } from "tslib";
import ApiManager from '@/managers/apimanagers';
export const useDashboard = () => {
    const _error = (err) => Promise.reject(err);
    const getDashboardList = () => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield ApiManager.get(`/crypto-staking-by-currency`).catch(_error);
        return data;
    });
    return { getDashboardList };
};
